
import u from "umbrellajs"
import _once from "lodash/once"
import _mapValues from "lodash/mapValues"

const $html = u("html")

const Page = _mapValues({
  isForMobile:  () => $html.hasClass("page-mobile") ,
  isForDesktop: () => $html.hasClass("page-desktop"),
  isForTablet:  () => $html.hasClass("page-desktop"),
}, (func) => _once(func))

const Device = _mapValues({
  isForMobile:  () => $html.hasClass("with-mobile-device") ,
  isForTablet:  () => $html.hasClass("with-tablet-device") ,
  isForDesktop: () => $html.hasClass("with-desktop-device"),
}, (func) => _once(func))

export {Page, Device}
export default {Page, Device}
